import { axiosInstance } from "../../utils/api"

export const getGalleriesByUser = async () => {
    return await axiosInstance.get('/galleries/owner');
}